import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../components/dataDisplay/dataDisplay";

export const DataPoints = memo(function DataPoints() {
  const dataPoints = useSelector((state) => state.rawDataTable.dataPoints);

  if (!dataPoints || !dataPoints.length) return null;
  return (
    <div className="data-points">
      {dataPoints.map((dataPointsRow, idx) => (
        <div key={`${idx}-row`} className="data-point data-point-row">
          {dataPointsRow.map(({ label, value }) => (
            <DataDisplay key={label} label={label} value={value} />
          ))}
        </div>
      ))}
    </div>
  );
});
